import { axiosInstance } from "./axiosService";

export const getLogin = (email, password, rememberMe = true) => {
  const userParams = {
    user: {
      email,
      password,
      remember_me: rememberMe ? "true" : "false",
    },
  };

  return axiosInstance.post("/users/log_in", userParams).catch((error) => {
    console.error("Error during login:", error);
    throw error;
  });
};

export const getLogout = () => axiosInstance.delete("/users/log_out");
